
import { autoWebViewJs, isRealInAndroid } from "@droid/android";

import { androidController, autoJsStoreUtils } from "@droid/android";
// import { projectController } from "@droid/project";
// import { initTriggers, projectInterfaceController } from "@droid/project-interface";
// import { initActions } from "@droid/project-interface/";
import { Dispatcher, browserHistoryUtils, listenDocumentActive, storeUtils, tabActivity } from "@fanfanlo";
import { user } from "../../user/User";
import { initAndroid } from "./initAndroid";
// @autobind
class AppController extends Dispatcher{
    constructor(){
        super()
    }
    async init(){
        const storeUtilsConf = {
            read: autoJsStoreUtils.read,
            write: autoJsStoreUtils.write,
            ns: {}
        }
        listenDocumentActive()
        // projectInterfaceController.init();
        browserHistoryUtils.initBrowserHistoryListener()
        // await projectController.init()
        await initAndroid()
        // initJsBridge()
        await androidController.init();
        autoWebViewJs?.onDocumentReady()
        if(autoWebViewJs){
            Object.defineProperty(window, 'autoWebViewJs', {
                value: autoWebViewJs,
                writable: false,
                configurable: false,
                enumerable: false  // 可选：不让它出现在 for...in 中
              });
            //   (global as any).autoWebViewJs = autoWebViewJs;
            // lockMethods(autoWebViewJs)
        }
        (window as any).storeUtilsConf = storeUtilsConf;
        tabActivity.init()
        // initActions()
        // initTriggers()
        if(isRealInAndroid){
            storeUtils.setStoresProxy({
                read: autoJsStoreUtils.read,
                write: autoJsStoreUtils.write,
                ns: {}
            });
        }
        // await user.init()
        // 不阻塞
        // 不需要阻塞，现在不需要初始化时必须先登录
        initDependOnRemote();
    }
}

async function initDependOnRemote(){
    await user.init();
}
export const appController = new AppController()